import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { CountryShared } from '../../../../../shared/models/interface/country.interface';
import { CityShared } from '../../../../../shared/models/interface/cityShared.interface';
import { CediPoint, Company } from 'src/app/components/shared/models/interface/parametrizacion.interface';
import { Flags } from 'src/app/components/shared/types/flags.type';

@Component({
  selector: 'app-new-routing-search-form-component',
  templateUrl: './new-routing-search-form-component.component.html',
  styleUrls: ['./new-routing-search-form-component.component.sass']
})
export class NewRoutingSearchFormComponentComponent<FlagType> extends MuComponent {

  @Input() flagList: Flags<FlagType>;
  @Input() showCreateCediFlag: FlagType;
  @Input() continueToDeliveries: FlagType;
  @Input() formData: UntypedFormGroup = new UntypedFormGroup({});
  @Input() coutriesListInput: CountryShared[];
  @Input() citiesListInput: CityShared[];
  @Input() companiesListInput: Company[];
  @Input() cediPointsListInput: CediPoint[];

  constructor() {
    super();
  }

  muOnInit(): void {
    /** */
  }

  muOnDestroy(): void {
    /** */
  }
}
